class CartDrawerItemAccidentPlanActions extends HTMLElement {
  constructor() {
    super();
    this.accidentsPlanData = this.getAccidentsPlanData();
    this.accidentPlanId = +this.dataset.accidentPlanId;
    this.accidentPlanName = this.dataset.accidentPlanName;

    this.productVariantId = +this.dataset.productVariantId;
    this.productProperties = this.getProductOptions();
    this.productAccidentPlan = this.getProductAccidentPlan();
  }

  connectedCallback() {
    this.initElements();
    this.initCallbackFunctions();
    this.showAddAccidentPlanBtn();
  }

  disconnectedCallback() {
    // this.changeAccidentPlanBtn?.removeEventListener("click");
    // this.addAccidentPlanBtn?.removeEventListener("click");
    // this.removeAccidentPlanBtn?.removeEventListener("click");
  }

  initElements() {
    this.changeAccidentPlanBtn = this.querySelector(".change-accident-plan");
    this.addAccidentPlanBtn = this.querySelector(".add-accident-plan");
    this.removeAccidentPlanBtn = this.querySelector(".remove-accident-plan");
  }

  initCallbackFunctions() {
    this.changeAccidentPlanBtn?.addEventListener("click", (eve) => {
      let btn = eve.target.closest(".change-accident-plan");
      if (!btn) return;

      let changeAccidentPlanEvent = new CustomEvent("changeAccidentPlanEvent", {
        detail: {
          productAccidentPlan: this.productAccidentPlan,
          productVariantId: this.productVariantId,
          productProperties: this.productProperties,
        },
      });
      document.dispatchEvent(changeAccidentPlanEvent);
    });

    this.addAccidentPlanBtn?.addEventListener("click", (eve) => {
      let btn = eve.target.closest(".add-accident-plan");
      if (!btn) return;
      let addAccidentPlanEvent = new CustomEvent("addAccidentPlanEvent", {
        detail: {
          productAccidentPlan: this.productAccidentPlan,
          productVariantId: this.productVariantId,
          productProperties: this.productProperties,
        },
      });
      document.dispatchEvent(addAccidentPlanEvent);
    });

    this.removeAccidentPlanBtn?.addEventListener("click", (eve) => {
      let btn = eve.target.closest(".remove-accident-plan");
      if (!btn) return;
      let removeAccidentPlanEvent = new CustomEvent("removeAccidentPlanEvent", {
        detail: {
          productAccidentPlan: this.productAccidentPlan,
          productVariantId: this.productVariantId,
          productProperties: this.productProperties,
        },
      });
      document.dispatchEvent(removeAccidentPlanEvent);
    });
  }

  showAddAccidentPlanBtn() {
    if (!this.addAccidentPlanBtn || !this.productAccidentPlan) return;
    let productHasAccidentPlan =
      Object.entries(this.productAccidentPlan).length > 0;
    if (productHasAccidentPlan) this.addAccidentPlanBtn.style.display = "flex";
  }

  getAccidentsPlanData() {
    return JSON.parse(
      document.querySelector("#accident-plan-component-metaobject-data")
        .textContent
    ).globalProtectionPlan;
  }

  getProductAccidentPlan() {
    return this.accidentsPlanData.find((acc) => {
      return acc.productsCovered.some((prod) =>
        prod.productVariants.includes(this.productVariantId)
      );
    });
  }

  getProductOptions() {
    return JSON.parse(
      document.querySelector(
        `#cart-drawer-item--accident-plan-properties-${this.productVariantId}`
      ).textContent
    );
  }
}
customElements.define(
  "cart-drawer-item-accident-plan-actions",
  CartDrawerItemAccidentPlanActions
);
